/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_New_Day_LabelInputs */

const en_us2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a workout`)
};

const pt_br2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar treino`)
};

const es_419_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar entrenamiento`)
};

const pt_pt2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar treino`)
};

const fr_fr2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une séance`)
};

const de_de2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training hinzufügen`)
};

const it_it2_plan_build_new_day_label = /** @type {(inputs: Plan_Build_New_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un allenamento`)
};

/**
* | output |
* | --- |
* | "Add a workout" |
*
* @param {Plan_Build_New_Day_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_new_day_label = /** @type {((inputs?: Plan_Build_New_Day_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_New_Day_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_new_day_label(inputs)
	if (locale === "es-419") return es_419_plan_build_new_day_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_new_day_label(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_new_day_label(inputs)
	if (locale === "de-DE") return de_de2_plan_build_new_day_label(inputs)
	if (locale === "it-IT") return it_it2_plan_build_new_day_label(inputs)
	return en_us2_plan_build_new_day_label(inputs)
});
export { plan_build_new_day_label as "plan-build.new_day_label" }